import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div style={{ padding: '2rem', maxWidth: 800, margin: 'auto', fontFamily: 'sans-serif', lineHeight: 1.6 }}>
      <h1>Privacy Policy</h1>

      <p>Your privacy is important to PanAm Explorer ("we", "us", "our"). This Privacy Policy explains how we collect, use, and protect your personal data when you use the PanAm Explorer app, website, and services.</p>

      <h2>What Personal Data We Collect</h2>

      <p>When you <a href="/profile">create an account</a> with PanAm Explorer, we may collect:</p>
      <ul>
        <li>Your name, email address, and password.</li>
        <li>Optional profile information such as profile photo, bio, and preferences.</li>
        <li>Location data you choose to share, such as live location for map features.</li>
        <li>Usage data such as IP address, device information, and app interaction details.</li>
      </ul>

      <h2>How We Use Your Data</h2>
      <ul>
        <li>To provide and maintain your account and the app features.</li>
        <li>To personalize your experience and connect you with other users.</li>
        <li>To communicate important updates, security alerts, and changes to our services.</li>
        <li>To send marketing communications, if you consent. You can unsubscribe anytime.</li>
        <li>To improve our app through analytics and usage data.</li>
      </ul>

      <h2>Your Choices and Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Access, update, or delete your personal information via your account settings.</li>
        <li>Opt-out of marketing communications at any time.</li>
        <li>Withdraw consent for location sharing by disabling the feature in the app.</li>
        <li>Request data portability or deletion by contacting us.</li>
      </ul>

      <h2>Sharing Your Data</h2>
      <p>Your profile information and shared location data may be visible to other users within the app to facilitate social and map features.</p>
      <p>We may share your data with trusted third-party service providers for hosting, analytics, payment processing, and customer support, under strict confidentiality agreements.</p>

      <h2>Data Security</h2>
      <p>We use industry-standard security measures to protect your data both in transit and at rest. However, no system is completely secure, so please use caution when sharing sensitive information.</p>

      <h2>International Data Transfers</h2>
      <p>Your data may be stored and processed on servers located in the United States and other countries where we or our service providers operate.</p>

      <h2>Children’s Privacy</h2>
      <p>PanAm Explorer is not intended for children under 13 years old. We do not knowingly collect personal data from children under 13.</p>

      <h2>Changes to This Privacy Policy</h2>
      <p>We may update this Privacy Policy from time to time. We will notify you of any significant changes via email or in-app notifications.</p>

      <h2>Contact Us</h2>
      <p>If you have any questions or requests regarding your personal data or this Privacy Policy, please contact us at <a href="mailto:panamexplorer@gmail.com">panamexplorer@gmail.com</a>.</p>

      <hr />
      <small>© 2025 PanAm Explorer</small>
    </div>
  );
}
